export class Smgdealer {
        id : number;
        vendorRegistrationId : string;
        applicationNumber : string;
        applicationDate : Date;
        dealWith : string;
        smgNo : string;
        smgId : string;
        description : string;
        principal_Company_Name : string;
        address : string;
        telephone : string;
        nameOfContactPerson : string;
        email : string;
        mobileNo : string;
        financialYear1 : string;

        poNo1 : string;
        poDate1 : Date;
        poValue1 : string;
        compilationDate1 : Date;
        client1 : string;
        briefDescriptionofWork1 : string;
        evaluatorsFigure1 : string;
        comments1 : string;

        poNo2 : string;
        poDate2 : Date;
        poValue2 : string;
        compilationDate2 : Date;
        client2 : string;
        briefDescriptionofWork2 : string;
        evaluatorsFigure2 : string;
        comments2 : string;

        poNo3 : string;
        poDate3 : Date;
        poValue3 : string;
        compilationDate3 : Date;
        client3 : string;
        briefDescriptionofWork3 : string;
        evaluatorsFigure3 : string;
        comments3 : string;

        totalPoValue : string;
        comments_Total_Value : string;
        avgPoValue : string;
        modified : Date;
        created : Date;
        modifiedBy : string;
        createdBy : string;
}
